/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { GmLogo } from '@vaas/react-ui-kit';
import { ProgressTrack } from './ProgressTrack';
import './loading.css';

/**
 * Full-screen gate for the auth handshake and any top-level route chunk that suspends after boot.
 * Drawn to match the splash inlined in index.html, deliberately - keep the two in step.
 */
export function BootScreen({ status }: { status?: string }) {
  const { t } = useTranslation();
  return (
    <div className="ld-boot" role="status" aria-label={status ?? t('common.loading')}>
      <div className="ld-boot-inner">
        <GmLogo className="ld-mark" size={44} decorative />
        <span className="ld-wordmark">eDiagnostics</span>
        {status && <span className="ld-status">{status}</span>}
        <ProgressTrack />
      </div>
    </div>
  );
}
